import { Box, Text } from '@rsos/base-components';

const EmptyState = ({ owner }: { owner?: string }) => (
  <Box p={4} align="center" justify="center" width="100%" flow={8}>
    <Text size="large" fontWeight="bold" color="primaryText">
      {owner === 'rapidsos' ? 'No Suggested Messages' : 'No Custom Messages'}
    </Text>
    <Box maxWidth="200px">
      <Text color="secondaryText" textAlign="center">
        {owner === 'rapidsos'
          ? 'We were unable to display any suggested messages.'
          : 'Please create a new message to utilize custom Preconfigured Messages.'}
      </Text>
    </Box>
  </Box>
);

export default EmptyState;
